import React from 'react';
import LiveTvTable from './compnents/live-tv-table/live-tv-table';

const LiveTv: React.FC = () => {
  return (
    <div className="w-full h-full">
      <LiveTvTable />
    </div>
  );
};

export default LiveTv;
